import { render, staticRenderFns } from "./KernelProducts.vue?vue&type=template&id=39d41882&"
import script from "./KernelProducts.vue?vue&type=script&lang=js&"
export * from "./KernelProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports